const isAndroidDevice = (userAgent = navigator.userAgent) =>
  /(android)/i.test(userAgent)

const isIOsDevice = (userAgent = navigator.userAgent) =>
  /iPad|iPhone|iPod/.test(userAgent)

const isAndroidWebview = (userAgent = navigator.userAgent) =>
  isAndroidDevice(userAgent) && /; wv\)/.test(userAgent)

const isIOsWebview = (userAgent = navigator.userAgent) =>
  isIOsDevice(userAgent) && !userAgent.toLowerCase().includes('safari')

const getOperatingSystem = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera

  if (/windows nt/i.test(ua)) {
    return 'Windows'
  }

  if (/macintosh|mac os x/i.test(ua)) {
    return 'macOS'
  }
  if (/linux/i.test(ua)) {
    return 'Linux'
  }
  if (/android/i.test(ua)) {
    return 'Android'
  }
  if (/iphone|ipad|ipod/i.test(ua)) {
    return 'iOS'
  }

  return 'other'
}

const getDeviceType = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera

  if (/mobile/i.test(ua)) {
    return 'Mobile'
  }

  if (/tablet|ipad|playbook|silk/i.test(ua)) {
    return 'Tablet'
  }

  if (/android/i.test(ua) && !/mobile/i.test(ua)) {
    return 'Tablet'
  }

  return 'Desktop'
}

export {
  isAndroidDevice,
  isIOsDevice,
  isAndroidWebview,
  isIOsWebview,
  getOperatingSystem,
  getDeviceType,
}
